module.exports = __webpack_public_path__ + "img/1.3bc3be45.png";